<template>
   <HeaderDash />
   <SideMenu /> 
   <ContentToDo /> 
</template>
<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/manager/dashboard/HeaderDash.vue'
import SideMenu from '@/components/manager/dashboard/SideMenu.vue'
import ContentToDo from '@/components/manager/dashboard/modules/to-do/ContentToDo.vue'

export default 
{
  name: 'ToDo',
  components: 
  {
    HeaderDash,
    SideMenu,
    ContentToDo
  }
}
</script>
<style>

</style>